import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';

import logoCarrefour from "../../assets/images/logo.png";
import logoAtacadao from "../../assets/images/atacadao-logo.png";

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import { Logo } from "../../components/design/layout/logo";
import Button from "../../components/design/form/button";

import UserTerms from '../../services/UserTerms';
import Swal from 'sweetalert2';

import {
    Wrapper,
    Header,
    HeaderContent,
    WrapLogo,
    IconDescription,
    IconWrapper,
    WrapInfo,
    TermsTitle,
    TermsDate,
    BottomPageActions,
    WrapButtons,
    Content,
    ContentBlock,
} from './styles';

function Terms({ website }) {

    const history = useHistory();
    const [termInformation, setTermInformation] = useState();
    const [isReadOnly, setIsReadOnly] = useState({ isVisible: false });

    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const readonly = params.get("readonly");

    const checkUserTerm = React.useCallback(async () => {
        const userTerms = new UserTerms();

        const userTermsResponse = await userTerms.checkUserTerms()
            .catch((error) => userTerms.formatErrorMessage(error.response, 'UTLT'));

        if (userTermsResponse && userTermsResponse.data && userTermsResponse.data.type === 'success') {
            if (userTermsResponse.data.code !== 0) {
                //REDIRECT PARA TELA DE TERMOS
                setTermInformation(userTermsResponse.data.payload);
                setIsReadOnly({ isVisible: false });

            } else {
                if (readonly) {
                    setTermInformation(userTermsResponse.data.payload);
                    setIsReadOnly({ isVisible: true });
                }
                // history.push({pathname: '/', search: history.location.search });
            }
        } else {
            Swal.fire(userTermsResponse.data.title, userTermsResponse.data.message, userTermsResponse.data.type);
        }
    }, [readonly]);


    const activeUserTerm = async () => {
        const userTerms = new UserTerms();

        if (termInformation) {
            const activateUserTerm = await userTerms.acceptTerms({ termID: termInformation._id })
                .catch((error) => userTerms.formatErrorMessage(error.response, 'UTAT'));

            if (activateUserTerm && activateUserTerm.data && activateUserTerm.data.type === 'success') {
                Swal.fire('', 'Termo aceito', 'success').then(() =>
                    history.push({ pathname: '/', search: history.location.search }));
            } else {
                Swal.fire(activateUserTerm.data.title, activateUserTerm.data.message, activateUserTerm.data.type);
            }
        } else {
            Swal.fire('', 'Nenhum termo localizado para o aceite', 'info');
        }

    }

    const recuseUserTerm = () => {
        Swal.fire({
            title: 'Termos e Condições',
            html: `<p>Você precisa aceitar os <b>Termos e Condições para acessar a central de benefícios</b>.<br/> Caso
            não queira fazer isso nesse momento, você deve fechar a página clicando no
            botão <b>"X"</b> que está no canto superior direito da tela.
         </p>`,
            confirmButtonText: 'Ok, entendi',
            icon: 'error',
            customClass: `terms-conditions-${website}`
        });
    }

    useEffect(() => {
        checkUserTerm();
    }, [checkUserTerm]);

    const handleHistory = () => {
        history.goBack();
        return history.goBack();
    };

    const justifyContent = {
        'space-between': "space-between",
        center: "center",
        start: "start",
        end: "end",
    }

    return (
        <>
            <Wrapper>
                <Header>
                    <HeaderContent>
                        <WrapLogo flexPosition={justifyContent['center']}>
                            <Logo link="/" image={website === "atacadao" ? logoAtacadao : logoCarrefour} alt="Carrefour" />
                            {/* {!isReadOnly.isVisible && (
                                    <ButtonClose type='button' onClick={recuseUserTerm}>
                            <I icon={['far', 'times']} size="lg" color="#2F3640" />
                            </ButtonClose>
                        )} */}
                        </WrapLogo>
                        <IconDescription>
                            <IconWrapper
                                iconBg={website === "carrefour" ? '#e7edfa' : '#26620014'}
                                iconColor={website === "carrefour" ? '#1E5BC6' : '#266200'}
                                className={`${isReadOnly.isVisible ? 'go-back' : ''}`}
                                onClick={isReadOnly.isVisible ? handleHistory : null}
                            >
                                <Icon icon={isReadOnly.isVisible ? ["far", "chevron-left"] : ["far", "list-alt"]} />
                            </IconWrapper>
                            <WrapInfo>
                                <TermsTitle>Termos e condições</TermsTitle>
                                <TermsDate>Ultima Atualização: {termInformation?.lastUpdate}</TermsDate>
                            </WrapInfo>
                        </IconDescription>
                    </HeaderContent>
                </Header>

                <Content className={`${isReadOnly.isVisible ? 'readonly' : ''}`}>
                    <ContentBlock dangerouslySetInnerHTML={{ __html: termInformation?.term }}></ContentBlock>
                </Content>

                {!!termInformation?.term ?

                    !isReadOnly.isVisible && (
                        <BottomPageActions>
                            <WrapButtons>
                                <Button
                                    onClick={recuseUserTerm}
                                    styleType="bordered"
                                    buttonSize="medium"
                                    buttonColor={props => props.theme[website]?.pages.terms.actions.decline.button}
                                    textColor={props => props.theme[website]?.pages.terms.actions.decline.text}
                                    borderColor={website === "carrefour" ? '#1E5BC6' : '#266200'}
                                    buttonText="Recusar"
                                    maxWidth={300}
                                />

                                <Button
                                    onClick={activeUserTerm}
                                    disabled={!termInformation}
                                    styleType="default"
                                    buttonSize="medium"
                                    buttonColor={props => props.theme[website]?.button.background}
                                    textColor={props => props.theme[website]?.button.color}
                                    borderColor={props => props.theme[website]?.button.background}
                                    buttonText="Aceitar"
                                    maxWidth={300}
                                />
                            </WrapButtons>
                        </BottomPageActions>
                    )
                    : ''}
            </Wrapper>
        </>
    )
};

const mapStateToProps = (state) => ({
    site_properties: state.websiteReducer.site_properties,
    website: state.websiteReducer.website
})

export default withRouter(connect(mapStateToProps, {})(Terms));
